import React, { Fragment } from 'react';
import { arrayOf, node, shape } from 'prop-types';
import { getActivityTitleByVariantId, hasDatePassed } from '@paddl/utils-js';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { useWidth } from '../..';
import { TimelineItemWrapper, ActivityDate, ActivityYear, ActivityYearWrapper, ActivityDateInline, TimeLineElementWrapper } from './ActivityTimeline.styles';
const currentYear = new Date().getFullYear();
const getActivityDate = duration => {
  const {
    startDate,
    endDate,
    isCurrent
  } = duration;
  const {
    day,
    month,
    year
  } = !hasDatePassed(new Date(endDate.year, endDate.month, endDate.day)) || isCurrent === true ? startDate : endDate;
  return [day, month, year].join('/');
};
const getYearsWithActivities = activities => [...new Set(activities.map(activity => {
  var _activity$duration, _activity$duration$en;
  return ((_activity$duration = activity.duration) === null || _activity$duration === void 0 ? void 0 : (_activity$duration$en = _activity$duration.endDate) === null || _activity$duration$en === void 0 ? void 0 : _activity$duration$en.year) || currentYear;
}))];
const mapActivityWithElement = _ref => {
  let {
    activities,
    children
  } = _ref;
  return activities.map((activity, index) => ({
    activity,
    element: children[index]
  }));
};
const getActivitiesByYear = (year, mappedActivities) => mappedActivities.filter(_ref2 => {
  var _activity$duration2, _activity$duration2$e;
  let {
    activity
  } = _ref2;
  return year === (((_activity$duration2 = activity.duration) === null || _activity$duration2 === void 0 ? void 0 : (_activity$duration2$e = _activity$duration2.endDate) === null || _activity$duration2$e === void 0 ? void 0 : _activity$duration2$e.year) || currentYear);
});
export const ActivityTimeline = _ref3 => {
  let {
    activities,
    children
  } = _ref3;
  const mappedActivities = mapActivityWithElement({
    activities,
    children
  });
  const yearsWithActivities = getYearsWithActivities(activities);
  const width = useWidth();
  return /*#__PURE__*/React.createElement(React.Fragment, null, yearsWithActivities.map(endDate => /*#__PURE__*/React.createElement(Fragment, {
    key: endDate
  }, /*#__PURE__*/React.createElement(ActivityYearWrapper, {
    breakpoint: width
  }, /*#__PURE__*/React.createElement(ActivityYear, {
    breakpoint: width
  }, endDate)), /*#__PURE__*/React.createElement(Timeline, {
    align: "alternate"
  }, getActivitiesByYear(endDate, mappedActivities).map(_ref4 => {
    let {
      activity,
      element
    } = _ref4;
    return /*#__PURE__*/React.createElement(TimelineItemWrapper, {
      key: activity.id,
      type: getActivityTitleByVariantId(activity.variantId),
      breakpoint: width
    }, /*#__PURE__*/React.createElement(TimelineItem, null, width !== 'xs' && /*#__PURE__*/React.createElement(TimelineOppositeContent, {
      color: "textSecondary"
    }, /*#__PURE__*/React.createElement(ActivityDate, null, getActivityDate(activity.duration))), /*#__PURE__*/React.createElement(TimelineSeparator, null, width !== 'xs' && /*#__PURE__*/React.createElement(TimelineConnector, null), /*#__PURE__*/React.createElement(TimelineDot, {
      color: "inherit",
      variant: "outlined"
    }), /*#__PURE__*/React.createElement(TimelineConnector, null)), /*#__PURE__*/React.createElement(TimelineContent, null, width === 'xs' && /*#__PURE__*/React.createElement(ActivityDateInline, null, getActivityDate(activity.duration)), /*#__PURE__*/React.createElement(TimeLineElementWrapper, {
      breakpoint: width
    }, element))));
  })))));
};
ActivityTimeline.propTypes = {
  children: arrayOf(node),
  activities: arrayOf(shape({}))
};
ActivityTimeline.defaultProps = {
  children: [],
  activities: [{}]
};